import styled from '@emotion/styled';
import { Magnetic, Modal } from '@mitchell/react.component.ux';
import { Grid, withStyles } from '@material-ui/core';
import { PhotoCaptureScriptQuestionIds } from '../constants';
export const StyledFraudWarningModal = withStyles({
    header: {
        color: (props) => props.headerColor,
        backgroundColor: (props) => props.headerBackgroundColor,
        fontSize: Magnetic.fontSize16,
        fontWeight: Magnetic.fontWeightHeavy,
        padding: Magnetic.spacer16
    },
    headerCloseButton: {
        color: (props) => props.headerCloseButtonColor,
        '&:hover': { color: (props) => props.headerCloseButtonColor },
        fontSize: Magnetic.fontSize10,
        lineHeight: 3
    },
    footer: { backgroundColor: (props) => props.footerBackgroundColor, padding: '0' }
})(Modal);
export const ModalWrapperDiv = styled('div') `
	width: 100%;
`;
export const ModalTitleGrid = styled(Grid) `
	text-align: center;
	width: 100%;
	color: ${(props) => props.color};
`;
export const ModalContentWrapperDiv = styled('div') `
	width: 100%;
`;
const modalFooterHeight = `${Magnetic.spacer40} - 2* ${Magnetic.spacer08} - 1px`;
export const ModalContentDiv = styled('div') `
	width: 100%;
	height: calc(100% - ${modalFooterHeight});
	overflow: auto;
	padding: 0 ${Magnetic.spacer08};
`;
export const ModalFooterContentDiv = styled('div') `
	width: 100%;
	background-color: ${(props) => props.backgroundColor};
`;
export const ModalFooterContentWrapperDiv = styled(Grid) `
	justify-content: end;
	padding: ${Magnetic.spacer08};
	#${PhotoCaptureScriptQuestionIds.ID_I_UNSERSTAND_FRAUD_WARNING} {
		font-size: ${Magnetic.fontSize12};
	}
`;
export const ButtonContainer = styled('div') `
	width: 100%;
`;
//# sourceMappingURL=PhotoCaptureFraudWarningModal.style.js.map